/**
 * Error Detection - Severity Configuration
 * Shared severity level configuration used across all Error Detection components.
 */

import { ShieldCheck, AlertTriangle, AlertOctagon, Skull, XCircle } from 'lucide-react';

const severityConfig = {
  none: {
    label: 'OK',
    bg: 'bg-emerald-50',
    text: 'text-emerald-700',
    border: 'border-emerald-200',
    dot: 'bg-emerald-500',
    icon: ShieldCheck,
    accent: 'bg-emerald-500',
  },
  warning: {
    label: 'Warning',
    bg: 'bg-amber-50',
    text: 'text-amber-700',
    border: 'border-amber-200',
    dot: 'bg-amber-500',
    icon: AlertTriangle,
    accent: 'bg-amber-500',
  },
  critical: {
    label: 'Critical',
    bg: 'bg-orange-50',
    text: 'text-orange-700',
    border: 'border-orange-200',
    dot: 'bg-orange-500',
    icon: AlertOctagon,
    accent: 'bg-orange-500',
  },
  armageddon: {
    label: 'Armageddon',
    bg: 'bg-red-50',
    text: 'text-red-700',
    border: 'border-red-200',
    dot: 'bg-red-500',
    icon: Skull,
    accent: 'bg-red-600',
  },
  error: {
    label: 'SQL Error',
    bg: 'bg-purple-50',
    text: 'text-purple-700',
    border: 'border-purple-200',
    dot: 'bg-purple-500',
    icon: XCircle,
    accent: 'bg-purple-500',
  },
};

const getSeverityConfig = (severity) => severityConfig[severity] || severityConfig.none;

export { severityConfig, getSeverityConfig };
